import {styled} from "@mui/material/styles";
import {Box, Button, List, ListItem, Typography} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

export const CardStyles = styled(Button)(() => ({
  width: '50%',
  height: '7.1em',
  borderRadius: '0.8em',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const Flex = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1em',
}));

export const CardTitleDefault = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'payWithAch',
})(({ payWithAch }) => ({
  fontFamily: 'Inter',
  fontSize: '1em',
  color: payWithAch ? '#000000' : '#fff',
  fontWeight: '500',
  textTransform: 'capitalize',
  marginTop: '0.5em',
}));

export const PaymentAch = styled(Button)(({ theme }) => ({
  height: '3em',
  textTransform: 'capitalize',
  borderRadius: '0.8em !important',
  fontFamily: 'Inter',
  fontSize: '0.8em',
  fontWeight: '500',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1em',
  }
}));

export const Title = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '1.14em',
  fontWeight: '400',
  lineHeight: '1.78em',
  marginBottom: '.7em',
  marginTop: '.6em',
}));

export const CardContent = styled(Box)(() => ({
  backgroundColor: '#F5F5F5',
  padding: '0.8em',
  borderRadius: '0.5em',
  marginTop: '1em',
  marginBottom: '1em',
}));

export const CardContentFooter = styled(Box)(() => ({
  marginBottom: '.3em',
}));

export const PaymentListTitle = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontSize: '1em',
  fontWeight: '500',
  color: '#000000',
}));

export const PaymentListDescription = styled(ListItem)(() => ({
  fontFamily: 'Inter',
  fontSize: '0.9em',
  fontWeight: '400',
  color: 'rgba(0, 0, 0, 0.6)',
  lineHeight: '1.28em',
  padding: '0em',
}));

export const PaymentListItem = styled(List)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5em',
  padding: '0em',
}));

export const PaymentListIcon = styled(FiberManualRecordIcon)(() => ({
  fontSize: '0.5em',
  color: 'rgba(0, 0, 0, 0.6)',
}));
